import { z } from "zod";
import { normalizePersonalityName } from "@dayvise/domain";

const text = z.union([z.string().max(32_000), z.array(z.string().max(8_000)).max(32)]);
export const PersonalityDefinitionSchema = z.union([text, z.object({
  systemPrompt: text.optional(), description: z.string().max(500).optional(),
  tone: z.string().max(2_000).optional(), style: z.string().max(2_000).optional(),
}).strict()]);
export const PersonalitiesSchema = z.record(PersonalityDefinitionSchema).superRefine((definitions, ctx) => {
  const names = new Set<string>();
  if (Object.keys(definitions).length > 50 || JSON.stringify(definitions).length > 64_000) ctx.addIssue({ code: "custom", message: "At most 50 custom personalities and 64,000 characters are allowed." });
  for (const name of Object.keys(definitions)) {
    const canonical = normalizePersonalityName(name);
    if (!canonical || !/^[a-z0-9][a-z0-9_-]{0,63}$/.test(canonical) || names.has(canonical)) ctx.addIssue({ code: "custom", path: [name], message: "Use a unique non-neutral personality name (letters, numbers, hyphens or underscores)." });
    names.add(canonical);
  }
}).transform((definitions) => Object.fromEntries(Object.entries(definitions).map(([name, definition]) => [normalizePersonalityName(name), definition])));
export const PersonalityNameSchema = z.string().max(64).nullable().transform((value) => normalizePersonalityName(value) || null);
